import { render } from "./FormFront.vue?vue&type=template&id=2bdd7f9c&ts=true"
import script from "./FormFront.vue?vue&type=script&lang=ts"
export * from "./FormFront.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__